import { useNavigate } from 'react-router-dom';
import { BackToComponentButton } from './backToComponentButton/BackToComponentButton';

interface IBackButtonProps {
    haveUnsavedChanges?: boolean;
    backUrl?: string;
}

const BackButton = ({ haveUnsavedChanges, backUrl }: IBackButtonProps) => {
    const navigate = useNavigate();

    const callBackNavigate = () => {
        if (backUrl) {
            navigate(backUrl);
        } else {
            navigate(-1);
        }
    };
    const returnBack = () => {
        if (haveUnsavedChanges) {
            if (window.confirm('Any unsaved changes will be lost!')) {
                callBackNavigate();
            }
        } else {
            callBackNavigate();
        }
    };

    return <BackToComponentButton onBackClick={returnBack} />;
};

export default BackButton;
